module.exports = __webpack_public_path__ + "7a32125370412a7576fee93fb3e1d39d.fbx";